import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';

import { FRAGMENT_IMAGE_STYLE } from './schema';

const MUTATION = gql`
  mutation CreateImageStyle($visualLanguageId: ID!, $name: String!, $resourceIds: [ID!]!) {
    createImageStyle(
      visualLanguageId: $visualLanguageId
      name: $name
      customerResourceIds: $resourceIds
    ) {
      ...ImageStyle
    }
  }
  ${FRAGMENT_IMAGE_STYLE}
`;

export const createImageStyle = async ({ visualLanguageId, name, resourceIds }) => {
  const variables = {
    visualLanguageId,
    name,
    resourceIds,
  };

  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
  });
  return getSingleProp(result.data);
};
